import { useState, useEffect } from 'react'
import * as XLSX from 'xlsx';
import { read, utils, writeFileXLSX } from 'xlsx';
import {  toast } from 'react-toastify';
import {checkExceptionFormat, checkExcDuplication, checkFormat,formatBytes,checkDuplication, removeSuffix} from '../assets/FileCheck';
import {Link} from 'react-router-dom';
import { Form,Button } from 'react-bootstrap';
import Pool from "./UserPool";
import Tnedata from "../services/data";
import {BiFile, BiCog, BiCalendar, BiUser} from "react-icons/bi";
import Papa from 'papaparse';

const ExpUploadCsv = ({toggle, logdata})=> {
    const [excfile, setExcFile] = useState();
    const [excfiledata, setExcFileData] = useState();
    const [col ,setCol]= useState();
    const [excstatus, setExcStatus] = useState("upload");
    const [isLoading, setIsLoading] = useState(false);
    //Button Enable and Disable
    const [isenable,setIsnable] = useState(true);
    const [iserror,setIserror] = useState(0);
    const [data, setData] = useState([]);
    const [excmetalog, setExcMetalog] = useState([]);
    const [excerror, setExcError] = useState(null);

    const user = sessionStorage.getItem("user")


    //old template column
    //const [excpreformat,setExcPreformat] = useState(['Org Unit 1 - Code', 'Employee', 'Employee ID', 'Report Name', 'Report ID', 'Date Last Submitted', 'Report Key', 'Expense Type','Transaction Date', 'Vendor', 'Amount', 'Entry Key', 'Exception Code','Exception Text', 'Cleared', 'Exception Code.1', 'Exception Text.1','Cleared.1', '# Header Exceptions', '# Entry Exceptions', 'Commenter','Report Header Comment', 'Commenter.1', 'Expense Line Comment']);
   //New template column
   // const [excpreformat,setExcPreformat] = useState(['Org Unit 1 - Code','Employee',	'Employee ID', 'Report Name', 'Report ID', 'Processor Start Date', 'Report Key', 'Expense Type', 'Transaction Date', 'Vendor','Amount',	'Entry Key','Exception Code', 'Exception Text', 'Cleared','Exception Code.1', 'Exception Text.1', 'Cleared.1', '# Header Exceptions','# Entry Exceptions',	'Commenter', 'Report Header Comment','Commenter.1','Expense Line Comment','Approval Status'])
   // const [excpreformat,setExcPreformat] = useState(['Org Unit 1 - Code', 'Employee', 'Employee ID', 'Report Name', 'Report ID', 'Processor Start Date', 'Report Key', 'Expense Type', 'Transaction Date', 'Vendor', 'Amount', 'Entry Key', 'Exception Code', 'Exception Text', 'Cleared', '# Header Exceptions', '# Entry Exceptions', 'Commenter', 'Report Header Comment', 'Expense Line Comment', 'Approval Status', 'Exception Code.1', 'Exception Text.1', 'Cleared.1', 'Commenter.1']) 
    const [excpreformat,setExcPreformat] = useState([ 'Org Unit 1 - Code','Employee',
      'Employee ID',
      'Report ID',
      'Report Name',
      'Exception Code',
      'Exception Text',
      'Exception Event',
      'Processor Start Date',
      'Transaction Date',
      'Associated Report Key',
      'Expense Type',
      'Expense Amount (reimbursement currency)',
      'Reimbursement Currency',
      'Approval Status'
      ]) 

    // console.log(excpreformat)
    const exchandleError = (error) => {
        // Handle the error here
        console.error("Error caught in OtherPage component:", error);
        // Check if error is not null and not undefined
    if (error !== null && error !== undefined) {
      const errorLength = error.length; // Assuming error is an array or a string
      setIserror(errorLength);
      //console.log("Receiving error length:", errorLength);
      // Determine whether to enable or disable based on error length
      setIsnable(true);
    } else {
      setIserror(0); // Set error length to 0 when there's no error
      setIsnable(false); // Disable when there's no error
    }
      };

      // Function to format dates to mm/dd/yyyy
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };


     //Data Upload Function
  const postcsvandlog= async () => {
    //console.log(excfiledata);
    const ctimestamp = Date.now(); 
    const currDate = new Date().toLocaleDateString("fr-CA");
    const currTime = new Date().toLocaleTimeString('en-GB', { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit'});
    const datetime = currDate+" "+ currTime;
    const currdatetime = new Intl.DateTimeFormat('en-IN', {year: 'numeric', month: '2-digit',day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'}).format(ctimestamp);
    const currentTime = new Date().toLocaleTimeString('en-GB', { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit'});
    const currentdatetime = currdatetime+" "+ currentTime;
    const filedate= excfile? excfile.lastModified : ''
    const fileDate = new Date(filedate).toLocaleDateString("fr-CA", );                                
    const fileTime = new Date(filedate).toLocaleTimeString('en-GB', { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit'});
    const filedatetime = fileDate+" "+ fileTime;
    const csvfileinfo = [{"filename":excfile.name, "filesize":formatBytes(excfile.size), "nooflines": excfiledata.length, "user":user, "timestamp":filedatetime, "create_at":datetime, "file_type":"exception"  }] ;
    //console.log(csvfileinfo);
    const cname = logdata.find(item => item.filename === excfile.name && item.filesize === formatBytes(excfile.size));
    
    if (logdata.length === 0){
      try {
      toast("Data uploading...");
      setExcStatus("LOADING...")
      const response1 = await Tnedata.upload_tne_exception(excfiledata);
      setExcStatus("Exception In Progress")
      await Tnedata.compute_exception_audits();
      setExcStatus("Pass-through In Progress")
      await Tnedata.compute_pass_through_audits();
     // await handlePostRequest()
     if(response1.data.message === "Exceptions Data inserted successfully"){
     toast("log uploading...");
      const response = await Tnedata.postLog(csvfileinfo);
      setExcStatus("UPLOAD COMPLETED")
     }
      ////console.log(cdata)
      //console.log(excfiledata);
      //console.log(response);
      //console.log(response1);
    } catch (error) {
     // console.error('Error: ' + error)
      setExcError('Error occurred please contact Administrator' );
    }
    }else{ //console.log(file.name +"===" + logdata[0].filename +"&&"+ formatBytes(file.size) +"==="+ logdata[0].filesize);
        if(cname){
          toast("Excel File Already Exits");
          setExcStatus("UPLOAD ")
          setIserror(1)
        }else{
          try {
          toast("Data uploading...");
          setExcStatus("LOADING...")
         // await postexpensejson(excfiledata);
          const response1 = await Tnedata.upload_tne_exception(excfiledata); 
          setExcStatus("Exception In Progress")
          await Tnedata.compute_exception_audits();
          setExcStatus("Pass-through In Progress")
          await Tnedata.compute_pass_through_audits();
         // await handlePostRequest()
          // console.log(response1)
          if(response1.data.message === "Exceptions Data inserted successfully"){
            toast("log uploading...");
            const response = await Tnedata.postLog(csvfileinfo);
            setExcStatus("UPLOAD COMPLETED")
            toast("Upload Completed...");
          }
          //console.log(response);
        } catch (error) {
         // console.error('Error: ' + error)
          setExcError('Error occurred please contact Administrator');
        }
        }
      }
    };

    const readUploadFile = async (e) => {
      e.preventDefault();
      setIserror(0)
      setExcStatus("UPLOAD ")
      setIsLoading(true);
      setExcStatus("Data Checking...");
      toast("Data Checking...");
      setExcFile(e.target.files[0]);

      const file = e.target.files[0];
     // console.log(file.size)
      // Check if the file size is below 10MB
      if (file.size > 10 * 1024 * 1024) { // 10MB in bytes
        toast.error("File size exceeds the maximum limit of 10MB.");
        setIsLoading(false);
        setExcStatus("Upload");
        return;
        }
        
      if (e.target.files) {
          const file = e.target.files[0];
          const reader = new FileReader(); 
          reader.onload = async (e) => {
              const arrayBuffer = e.target.result;
              const workbook = XLSX.read(arrayBuffer, { type: "array" });
              const sheetName = workbook.SheetNames[0];
              const worksheet = workbook.Sheets[sheetName];
              const csv = XLSX.utils.sheet_to_csv(worksheet);
              const result = Papa.parse(csv, {
                  header: true,
                  skipEmptyLines: true,
              });
              const jsonData = result.data;
              //console.log(Object.keys(jsonData[0]))
              // Further processing of jsonData
              const jsoncol = Object.keys(jsonData[0]);
             // console.log(jsoncol)
              setCol(jsoncol);
               // console.log(jsoncol)
               //console.log("excpreformat", excpreformat)
            //   if (jsoncol.length > 0 ) {
            //     jsoncol[15] = "Exception Code.1"; 
            //     jsoncol[16] = "Exception Text.1";
            //     jsoncol[17] = "Cleared.1";
            //     jsoncol[22] = "Commenter.1";
            //   } else {
            //     console.error("Index out of range");
            //   }

            //   const excmodifiedJson = jsonData.map(item => {
            //     const modifiedItem = { ...item };
            //     const keys = Object.keys(item);
            //     if (keys.length >= 16) {
            //         modifiedItem['Exception Code.1'] = modifiedItem[keys[15]];
            //         delete modifiedItem[keys[15]];
            //     }
            //     if (keys.length >= 17) {
            //         modifiedItem['Exception Text.1'] = modifiedItem[keys[16]];
            //         delete modifiedItem[keys[16]];
            //     }
            //     if (keys.length >= 18) {
            //       modifiedItem['Cleared.1'] = modifiedItem[keys[17]];
            //       delete modifiedItem[keys[17]];
            //    }
            //     if (keys.length >= 23) {
            //       modifiedItem['Commenter.1'] = modifiedItem[keys[22]];
            //       delete modifiedItem[keys[22]];
            //    }
            //     return modifiedItem;
            // });

            // const expjsoncol2 = Object.keys(excmodifiedJson[0]);
            // setCol(expjsoncol2);
  

            // const excmodifiedObject = [];
            // for (const key in expjsoncol2) {
            //   if (expjsoncol2.hasOwnProperty(key)) {
            //     excmodifiedObject[key] = removeSuffix(expjsoncol2[key]);
            //   }
            // }
  
            //console.log(jsoncol)

            //console.log(jsonData)
              await checkDuplication(jsoncol, excpreformat, exchandleError);
             // await checkExceptionFormat(jsoncol, excpreformat, exchandleError);
              await checkFormat(jsoncol, excpreformat, exchandleError);
              setExcFileData(jsonData);
          };
  
          reader.readAsArrayBuffer(file);
      }
  
      setIsLoading(false);
      setExcStatus("Upload");
  };
    
   //Import Button Function
   const handleOnSubmit = async (e) => {
    e.preventDefault();
    await postcsvandlog();
  };

 //console.log(iserror)
  //console.log(excfiledata);
  //console.log(JSON.stringify(excfiledata))
  //console.log(file);
  //console.log(!excfiledata ? "" :col);
  //console.log(isenable)

  //console.log(excfiledata);
  //console.log(file);
  //console.log(!excfiledata ? "" :col);

  const downloadexcExcel = () => {
    // Replace 'path_to_your_excel_file' with the actual path to your Excel file
    const excelFilePath = '/data_template/Exceptions_Data_Template.xlsx';
    window.open(excelFilePath);
  };


  return (
    <>
    <form>
        {isLoading ? "Please wait Loading...." : " " }
        <input type="file" name="upload" id="upload" onChange={readUploadFile} />
        <div className='text-center mt-1'>
        <Button variant="primary" type="submit" onClick={handleOnSubmit}  disabled={ iserror > 0 ? true  : false}  className='download'> {excstatus} </Button>    
        <Button onClick={(e) => {e.preventDefault(); window.open('location', '_self', ''); window.close(); }} className='btn mx-2 btn-primary download'>Exit</Button> 
        {/*logdata ? (<p className="text-left " style={{fontSize:"13px", lineHeight:"30px"}}><> <div  style={{display:"flex"}}><div style={{width:"70%"}} className="text-left" ><BiFile/>  {logdata ? logdata[0].filename: ""}  </div> <div style={{width:"30%"}}><BiCog/>  {logdata ? logdata[0].filesize :""}</div></div> </></p> ):  "Loading..."*/}
        {excerror && <p style={{color:"red"}}>Error: {excerror}</p>}
        {logdata.length === 0 ? "" :  <><div className="text-left" style={{fontSize:"13px", lineHeight:"30px"}}><><h6 className='mt-2'>Recent log</h6> <div ><div style={{width:"100%"}} className="text-left" ><BiFile/>  {logdata.length === 0  ? "" : logdata[0].filename}  </div> <div style={{width:"100%"}}><BiCog/>  {logdata.length === 0   ? "" : logdata[0].filesize}</div></div> </></div> </> }
        </div>
    </form>
    <div className={toggle ? "isexpanded": "ishide"}>
    <hr/>
    <div className='row'>
        <div className='col text-start'>
            <p className='text-center'>
            <button onClick={downloadexcExcel} className='btn btn-primary download'>Exceptions Template Download</button>
            {/* <Link to="/data_template/Exceptions_Data_template.xlsx" target="_blank" className='btn btn-primary download' download>Exceptions Template Download</Link> */}
            </p>
            <ul>
                <li>The data should be in the attached format.</li>
                <li>The data should be in xlsx format.</li>
                <li>Before uploading new data, auditing of existing data should be completed.</li>
            </ul>
        </div>
    </div>
    </div>
    </>
  )
}

export default ExpUploadCsv;